module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/永续经营-text.adb0536f.png";